export default {
  usergroups: [],
  activeUsergroup: null,
  requestStatus: 'loading',
};
